import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Redirect, Route } from "react-router-dom";

export const VKeyAdminRoute = (props) => {
    const { component: Component, ...rest } = props;
    const { context, isVKeyAdminUser } = useContext(AuthContext);

    return (
        <Route
            {...rest}
            render={(props) =>
                isVKeyAdminUser(context.user) ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/vkey/summary",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};
